import { render } from "./SelectTaskTypeModal.vue?vue&type=template&id=388981ce&ts=true"
import script from "./SelectTaskTypeModal.vue?vue&type=script&lang=ts"
export * from "./SelectTaskTypeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__